export class FilterListProjectINModel {
  codiceArmadio: string
  codiceCentrale: string
  comune: string
  statoLavorazione: string
}